export const basicFormFields: ContactFormControl = {
  nombre: {
    id: 'nombre',
    label: 'Nombre',
    placeholder: 'Nombre',
    value: '',
  },
  apellido: {
    id: 'apellido',
    label: 'Apellido',
    placeholder: 'Apellido',
    value: '',
  },
  email: {
    id: 'correoElectronico',
    label: 'Correo Electrónico',
    placeholder: 'Correo Electrónico',
    value: '',
  },
  confirmEmail: {
    id: 'confirmarCorreoElectronico',
    label: 'Confirmar Correo Electrónico',
    placeholder: 'Confirmar Correo Electrónico',
    value: '',
  },
  telefono: {
    id: 'telefono',
    label: 'Número de Teléfono',
    placeholder: 'Número de Teléfono',
    value: '',
  },
};

export interface ContactFormControl {
  [key: string]: {
    id: string;
    label: string;
    placeholder: string;
    dirty?: boolean;
    value: string;
    type?: 'input' | 'textarea';
    fullWidth?: boolean;
  };
}
